import * as Clipboard from '@rehaje/clipboard'
import * as Collaborator from '@rehaje/collaborator'
import * as Core from '@rehaje/core'
import * as Errors from '@rehaje/errors'
import * as Form from '@rehaje/form'
import * as FormCompat from '@rehaje/form-compat'
import * as Javascript from '@rehaje/javascript'
import * as Lowcode from '@rehaje/lowcode'
import * as Mustache from '@rehaje/mustache'
import * as React from '@rehaje/react'
import * as Reactive from '@rehaje/reactive'
import * as ReactiveReact from '@rehaje/reactive-react'
import * as Shared from '@rehaje/shared'

Object.assign(globalThis, {
  Rehaje: Object.freeze({
    ...globalThis.Rehaje,
    Clipboard,
    Collaborator,
    Core,
    Errors,
    Form,
    FormCompat,
    Javascript,
    Lowcode,
    Mustache,
    React,
    Reactive,
    ReactiveReact,
    Shared
  })
})

export * as Clipboard from '@rehaje/clipboard'
export * as Collaborator from '@rehaje/collaborator'
export * as Core from '@rehaje/core'
export * as Errors from '@rehaje/errors'
export * as Form from '@rehaje/form'
export * as FormCompat from '@rehaje/form-compat'
export * as Javascript from '@rehaje/javascript'
export * as Lowcode from '@rehaje/lowcode'
export * as Mustache from '@rehaje/mustache'
export * as React from '@rehaje/react'
export * as Reactive from '@rehaje/reactive'
export * as ReactiveReact from '@rehaje/reactive-react'
export * as Shared from '@rehaje/shared'
